import * as React from "react";
import { AppBar, Box, Toolbar } from "@mui/material";
import { Logo } from "./Logo";
import { UserMenu } from "./UserMenu";

const NavigationBar = ({
  children,
  callToAction,
}: {
  children?: React.ReactNode;
  callToAction?: React.JSX.Element;
}) => {
  return (
    <AppBar
      position="static"
      sx={{ color: "primary.contrastText", zIndex: 9999 }}
    >
      <Toolbar sx={{ minHeight: "4rem", height: "4rem" }}>
        <Logo />

        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            flexGrow: 1,
            gap: "1rem",
          }}
        >
          {children}
        </Box>
        {callToAction}
        <Box width="2rem"></Box>
        <UserMenu />
      </Toolbar>
    </AppBar>
  );
};

export default NavigationBar;
